"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtUserId = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtUserId = function SvgBtUserId(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#svg-bt-user-id__clip0)",
    fill: "currentColor",
    stroke: "#4676D9",
    strokeWidth: 0.15
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.08 15.816h0a.898.898 0 01.568.838v.869c0 .342-.279.62-.621.62h-.564a.339.339 0 010-.677h.507v-.812a.224.224 0 00-.141-.21l.251-.628zm0 0l-.842-.337m.842.337l-.842-.337m0 0v-.475c.178-.242.282-.54.282-.863v-.846c0-.668-.674-1.184-1.466-1.184-.791 0-1.466.516-1.466 1.184v.846c0 .322.105.62.282.863v.475l-.842.337h0a.898.898 0 00-.567.838v.869c0 .342.278.62.62.62h2.255a.339.339 0 000-.677H8.138v-.812c0-.093.056-.175.142-.21l.877-.35a.618.618 0 00.39-.576v-.002a1.457 1.457 0 001.014 0v.002c0 .255.153.481.39.576 0 0 0 0 0 0l.878.35-.59-.965zm-.395-1.338a.79.79 0 01-1.577 0v-.845c0-.125.078-.25.223-.348.144-.096.345-.16.565-.16.22 0 .422.064.566.16.145.098.223.223.223.348v.845z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.11 9.293h0c-.654 0-1.185.531-1.185 1.184v9.018c0 .653.531 1.184 1.184 1.184h15.782c.653 0 1.184-.53 1.184-1.184v-9.018c0-.653-.531-1.184-1.184-1.184h-5.018a.621.621 0 00-.618-.563h-.79A1.468 1.468 0 0014 7.32c-.79 0-1.435.627-1.465 1.41h-.79a.621.621 0 00-.62.62v.845c0 .343.278.621.62.621h4.51c.342 0 .62-.278.62-.62V9.97h5.016c.28 0 .507.227.507.506v9.018c0 .28-.228.507-.507.507H6.109a.507.507 0 01-.507-.507v-9.018c0-.28.228-.507.507-.507h4.227a.339.339 0 000-.677H6.11zm10.088.114v.732h-4.396v-.732h1.07a.339.339 0 00.34-.339v-.282a.79.79 0 011.577 0v.282c0 .187.151.339.338.339h1.07z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.007 8.448a.338.338 0 00-.343.335s0 0 0 0l-.003.282.604.006h.074l.002-.281h0a.339.339 0 00-.334-.342zm0 0s0 0 0 0l-.002.075.002-.075s0 0 0 0zm-.01.959h0l-.336-.342a.339.339 0 00.336.342zM20.355 12.648h-5.073a.339.339 0 000 .677h5.073a.339.339 0 000-.677zM19.509 14.184h-2.536a.339.339 0 000 .677h2.536a.339.339 0 100-.677zM15.845 14.184h-.563a.339.339 0 000 .677h.563a.339.339 0 000-.677z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "svg-bt-user-id__clip0"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M5 5h18v18H5z"
  }))));
};

exports.SvgBtUserId = SvgBtUserId;